export interface ImageRegistryItem {
  id: string;
  src: string;
  altSources?: string[];
  fallbackSrc?: string;
  category: 'team' | 'testimonial' | 'program' | 'gallery' | 'general';
  description: string;
  usageLocations: string[];
}

export const imageRegistry: ImageRegistryItem[] = [
  // Team Members
  {
    id: 'team-member-1',
    src: '/assets/team/team-member-1.jpg',
    category: 'team',
    description: 'Team member with professional headshot',
    usageLocations: ['Team Page', 'About Page']
  },
  {
    id: 'team-member-2',
    src: '/assets/team/team-member-2.jpg',
    category: 'team',
    description: 'Team member with professional headshot',
    usageLocations: ['Team Page']
  },
  
  // Program Images
  {
    id: 'mpower-program',
    src: '/assets/programs/mpower-program.jpg',
    category: 'program',
    description: 'MPOWER program image showing parent training session',
    usageLocations: ['Programs Page']
  },
  {
    id: 'soran-academy-program',
    src: '/assets/programs/soran-academy-program.jpg',
    category: 'program',
    description: 'SORAN Academy classroom environment',
    usageLocations: ['Programs Page', 'Home Page']
  },
  {
    id: 'be-special-program',
    src: '/assets/programs/be-special-program.jpg',
    category: 'program',
    description: 'BE SPECIAL program therapy session',
    usageLocations: ['Programs Page']
  },
  {
    id: 'homeschooling-benefits',
    src: '/assets/programs/homeschooling-benefits.jpg',
    category: 'program',
    description: 'Child learning in homeschool environment',
    usageLocations: ['Programs Page', 'Homeschooling Page']
  },
  
  // Testimonials
  {
    id: 'parent-1',
    src: '/assets/testimonials/parent-1.jpg',
    category: 'testimonial',
    description: 'Parent testimonial headshot',
    usageLocations: ['Programs Page', 'Home Page']
  },
  {
    id: 'parent-2',
    src: '/assets/testimonials/parent-2.jpg',
    category: 'testimonial',
    description: 'Parent testimonial headshot',
    usageLocations: ['Programs Page']
  },
  {
    id: 'parent-3',
    src: '/assets/testimonials/parent-3.jpg',
    category: 'testimonial',
    description: 'Parent testimonial headshot',
    usageLocations: ['Programs Page']
  },
  
  // Gallery Images
  {
    id: 'gallery-1',
    src: '/assets/gallery/gallery-1.jpg',
    category: 'gallery',
    description: 'Children in a therapy session',
    usageLocations: ['Gallery Page']
  },
  {
    id: 'gallery-2',
    src: '/assets/gallery/gallery-2.jpg',
    category: 'gallery',
    description: 'Parent workshop session',
    usageLocations: ['Gallery Page']
  },
  
  // General Images
  {
    id: 'mission-image',
    src: '/assets/mission-image.jpg',
    fallbackSrc: '/assets/general/placeholder.jpg',
    category: 'general',
    description: 'Image representing our mission',
    usageLocations: ['About Page']
  },
  {
    id: 'contact-image',
    src: '/assets/contact-image.jpg',
    fallbackSrc: '/assets/general/placeholder.jpg',
    category: 'general',
    description: 'Image for contact page',
    usageLocations: ['Contact Page']
  },
  {
    id: 'soran-logo',
    src: '/assets/logos/soranlogo.jpg',
    category: 'general',
    description: 'SORAN Foundation Logo',
    usageLocations: ['Header', 'Footer']
  },
  {
    id: 'bosse-certificate',
    src: '/assets/certificates/bosse-certificate.jpg',
    category: 'general',
    description: 'BOSSE Certificate of Affiliation for SORAN International School',
    usageLocations: ['Home Page', 'SORAN Academy Page']
  },
  {
    id: 'nupur-dube',
    src: '/assets/team/nupur.jpg',
    category: 'team',
    description: 'Nupur Dube, Founder of SORAN Foundation',
    usageLocations: ['About Page', 'Team Page']
  },
  {
    id: 'renu-dube',
    src: '/assets/team/Renu-Dube.jpg',
    category: 'team',
    description: 'Renu Dube, Co-founder & Director',
    usageLocations: ['About Page', 'Team Page']
  },
  {
    id: 'hema-nair',
    src: '/assets/team/Hema-Nair.jpg',
    category: 'team',
    description: 'Hema Nair, Head of Training & Development',
    usageLocations: ['About Page', 'Team Page']
  },
  {
    id: 'pooja-gusain',
    src: '/assets/team/Pooja-Gusain.jpg',
    category: 'team',
    description: 'Pooja Gusain, Head of Therapy Wing',
    usageLocations: ['About Page', 'Team Page']
  }
];

// Helper functions for working with the image registry
export const getImagesByCategory = (category: string) => {
  return imageRegistry.filter(img => img.category === category);
};

export const getImageById = (id: string) => {
  return imageRegistry.find(img => img.id === id);
};

export const getImagesByUsageLocation = (location: string) => {
  return imageRegistry.filter(img => img.usageLocations.includes(location));
};